/**
 * Tourism enquiry submission (M7-T01 endpoint). The one Phase-1 write — a
 * captured lead for the AMTC concierge; no payment, consent required.
 */
import { apiFetch } from '../lib/api'

export type EnquiryInput = {
  full_name: string
  email: string
  country_of_origin: string
  consent_data_handling: boolean
  phone?: string
  whatsapp?: string
  specialty_slug?: string
  preferred_hospital_slug?: string
  preferred_dates_text?: string
  condition_description?: string
  mobility?: string
}

export type EnquiryCreated = {
  reference: string
  status: string
}

/** POST /api/v1/enquiries — submit a lead. Throws `ApiError` on validation or
 * server failure (`error.fields` carries per-field messages on a 400). */
export async function submitEnquiry(
  input: EnquiryInput,
): Promise<EnquiryCreated> {
  const body = await apiFetch<{ data: EnquiryCreated }>('/api/v1/enquiries', {
    method: 'POST',
    body: input,
  })
  return body.data
}
